<template>
  <div class="relanameFooter">
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
      <component
        :is="contract"
        :hidePopup="hidePopup"
      ></component>
    </van-popup>
    <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
    <span>
      <span @click="clickAgree()">
        您授权我们收集您的姓名、身份证号、手机号，并将其提供给百融云创科技股份有限公司/贵州数据宝网络科技有限公司
        （联系方式请见
      </span>
      <a
        class="argrent"
        @click="PrivacyPClick"
      >《隐私政策》</a>
      ），
      <span @click="clickAgree()">以便获取实名认证结果。</span></span>
  </div>
</template>
<script>
import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';
import Privacypolicy from '@/components/FeildTwo/components/Privacypolicy.vue';
// 隐私政策
export default {
  name: 'relaNameFooter',
  data() {
    return {
      imgUrlAgreement: NoSelect,
      show: false,
      argementFlag: false,
      contract: 'Privacypolicy',

    };
  },
  props: ['changeArgementFlag'],
  components: {
    Privacypolicy,
  },
  methods: {
    clickAgree() {
      console.log('我点击了操作');
      console.log('changeArgementFlag=====', this.changeArgementFlag);
      console.log('wo dianji le caozuo ', this.argementFlag);
      this.imgUrlAgreement = !this.argementFlag ? Select : NoSelect;
      this.argementFlag = !this.argementFlag;
      this.changeArgementFlag(this.argementFlag);
    },
    PrivacyPClick() {
      this.show = true;
    },
    hidePopup() {
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.relanameFooter {
  color: #1c2438;
  font-size: 14px;
  padding: 0 16px;
  margin-top: 10px;
  text-align: left;
}
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}
.argrent {
  color: #ff6538;
}
.selectImg {
  width: 12px;
}
</style>
